import { Link } from '@inertiajs/react'
import { ReactNode } from 'react'
import { HiOutlineArrowLeft } from 'react-icons/hi2'

type Props = {
  backHref: string
  backLabel?: string
  title: ReactNode
}

export default function PageSubHeader({ backHref, backLabel = 'Back', title }: Props) {
  return (
    <div className="bg-white shadow-sm">
      <div className="mx-auto flex w-full max-w-[1440px] items-center gap-6 px-5 py-4 md:px-10">
        <Link
          href={backHref}
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-700 transition hover:bg-gray-50"
          aria-label={backLabel}
        >
          <HiOutlineArrowLeft className="h-5 w-5" />
        </Link>
        <h1 className="font-display text-[22px] font-semibold tracking-tight text-gray-900">
          {title}
        </h1>
      </div>
    </div>
  )
}
